import { useSelector } from 'react-redux';

const useMatchMedia = (size: IScreenSizeType) => {
    const screenType = useSelector((state) => state.appState.screenType);

    return screenType === size;
};

export default useMatchMedia;
